
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/oracle-db",
      function () {
        return require("private-next-pages/destinations/oracle-db.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/oracle-db"])
      });
    }
  